var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-style d-flex justify-flex-start pb-1 mb-4"},[_c('span',{staticClass:"font-weight-bold mr-8 text-start"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }